import Vue from 'vue';
import App from './app';

const vueOrderPopup = document.querySelector('[data-list-type="jsOrderList"]');
if (vueOrderPopup) {
  new Vue({
    el: vueOrderPopup,
    render(h) {
      return h(App);
    },
  });
}
